// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddPopularLocationManagement-commonHeaderAdmin-f8KVM {
	position: fixed !important;
}

.AddPopularLocationManagement-adminLayout-cG5WM {
	padding-top: 64px !important;
}

.AddPopularLocationManagement-box-hFql1 h2 {
	font-size: 21px;
	font-weight: 600;
}

.AddPopularLocationManagement-exportLink-t7iv6 {
	margin-bottom: -29px;
}

.AddPopularLocationManagement-blockCenter-rEtw4 {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.AddPopularLocationManagement-panelHeader-qiRIs {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.AddPopularLocationManagement-currencyselect-rsOD3 {
	width: 100%;
	margin-right: 0px;
}

.AddPopularLocationManagement-panelHeader-qiRIs {
	overflow: hidden;
	position: relative;
}

.AddPopularLocationManagement-mar0-yX7IM {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.AddPopularLocationManagement-blockCenter-rEtw4 {
		padding: 0px;
	}

	.AddPopularLocationManagement-panelHeader-qiRIs {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.AddPopularLocationManagement-sideAdminPageWrapper-cmt0e {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.AddPopularLocationManagement-panelHeader-qiRIs {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.AddPopularLocationManagement-table-y0oX7 {
	display: table;
}

.AddPopularLocationManagement-tableRow-vRSqv {
	display: table-row;
}

.AddPopularLocationManagement-tableCell-zqdOA {
	display: table-cell;
	float: none;
}

.AddPopularLocationManagement-formGroup-uucAE {
	margin-bottom: 6px;
}

.AddPopularLocationManagement-select-ZBWfP {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.AddPopularLocationManagement-noMargin-v0RbN {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.AddPopularLocationManagement-exportLink-t7iv6 {
	padding-top: 10px;
	padding-right: 10px;
}

.AddPopularLocationManagement-labelTextNew-tbQYD {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.AddPopularLocationManagement-displayInline-raarw {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.AddPopularLocationManagement-btnUPdate-P3moK {
	display: inline-block;
}

.AddPopularLocationManagement-btnModalDelete-zuWfs {
	display: inline-block;
	margin-left: 15px;
}

.AddPopularLocationManagement-radioBtn-qDjI6 {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.AddPopularLocationManagement-backgroundImg-ZS3Qv {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.AddPopularLocationManagement-btnUPdate-P3moK {
		display: block;
		margin-bottom: 12px;
	}

	.AddPopularLocationManagement-btnModalDelete-zuWfs {
		display: block;
		margin-left: 0px;
	}

	.AddPopularLocationManagement-btnWidth-VR0Wu {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.AddPopularLocationManagement-bannerImageBg-mft_Z {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.AddPopularLocationManagement-bannerDelete-sirYu {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.AddPopularLocationManagement-modalRoot-siG8d {
	padding: 32px;
}

.AddPopularLocationManagement-modalBorderBottom-yHR9F {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.AddPopularLocationManagement-logInModalBody-yVmG6 {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.AddPopularLocationManagement-exportSection-XHdLK {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.AddPopularLocationManagement-exportSectionGridSub-Ertvh {
	grid-template-columns: 50% 49% !important;
}

.AddPopularLocationManagement-exportText-_jOMc {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.AddPopularLocationManagement-exportLinkImg-raqYg {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.AddPopularLocationManagement-vtrMiddle-TdHey {
	vertical-align: middle;
}

.AddPopularLocationManagement-exportImg-jK_VZ {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AddPopularLocationManagement-profileViewlabel-kQ1Iy {
	display: inline-block;
	width: 38%
}

.AddPopularLocationManagement-profileViewMainContent-ZQr6M {
	display: inline-block;
	width: 62%;
}

.AddPopularLocationManagement-profileViewMain-gNLxd {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.AddPopularLocationManagement-profileViewInner-V_61m {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.AddPopularLocationManagement-profileImageSection-bOZNm {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.AddPopularLocationManagement-lastviewInner-_8Kfq {
	padding: 10px;
}

.AddPopularLocationManagement-whyHostHoriLine-fs3BY {
	margin: 30px 0;
}

.AddPopularLocationManagement-tableGrid-OWA5j {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.AddPopularLocationManagement-headingContent-htVCF {
	font-size: 18px;
	font-weight: 500;
}

.AddPopularLocationManagement-refundTextColor-rfQP4 {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.AddPopularLocationManagement-dividerLine-AYbCr {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.AddPopularLocationManagement-smallContent-WC074 {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.AddPopularLocationManagement-sideAdminPageWrapper-cmt0e {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.AddPopularLocationManagement-sideAdminPageWrapper-cmt0e {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.AddPopularLocationManagement-exportSection-XHdLK {
		grid-template-columns: 100%;
	}

	.AddPopularLocationManagement-exportSectionGridSub-Ertvh {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.AddPopularLocationManagement-profileViewlabel-kQ1Iy {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AddPopularLocationManagement-profileViewMainContent-ZQr6M {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.AddPopularLocationManagement-ChangeToUpperCase-C4jrV {
	text-transform: uppercase
}

.AddPopularLocationManagement-noBorder-guXlO {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.AddPopularLocationManagement-siteAdminHeading-OCy7T {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.AddPopularLocationManagement-siteAdminSubHeading-Pp2lE {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.AddPopularLocationManagement-adminFormDivider-XysWv {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.AddPopularLocationManagement-errorMessage-BSI9U {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.AddPopularLocationManagement-panelHeader-qiRIs {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.AddPopularLocationManagement-formGroup-uucAE {
  margin-bottom: 6px;
}

.AddPopularLocationManagement-select-ZBWfP {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.AddPopularLocationManagement-labelText-QqS6d {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.AddPopularLocationManagement-space1-fiNX0 {
	margin-bottom: 6px !important;
}

.AddPopularLocationManagement-space2-frGP3 {
	margin-bottom: 12px !important;
}

.AddPopularLocationManagement-space3-VC3A0 {
	margin-bottom: 18px !important;
}

.AddPopularLocationManagement-space4-ee3Wf {
	margin-bottom: 24px !important;
}

.AddPopularLocationManagement-space5-OhLzk {
	margin-bottom: 30px !important;
}

.AddPopularLocationManagement-space6-EO7L3 {
	margin-bottom: 36px !important;
}

.AddPopularLocationManagement-space7-V83PY {
	margin-bottom: 42px !important;
}

.AddPopularLocationManagement-spaceTop8-E6u11 {
	margin-bottom: 48px !important;
}

.AddPopularLocationManagement-spaceTop1-mTAeK {
	margin-top: 6px !important;
}

.AddPopularLocationManagement-spaceTop2-DLaFe {
	margin-top: 12px !important;
}

.AddPopularLocationManagement-spaceTop3-tNG5Z {
	margin-top: 18px !important;
}

.AddPopularLocationManagement-spaceTop4-sDLZB {
	margin-top: 24px !important;
}

.AddPopularLocationManagement-spaceTop5-LWwup {
	margin-top: 30px !important;
}

.AddPopularLocationManagement-spaceTop6-DaH0O {
	margin-top: 36px !important;
}

.AddPopularLocationManagement-spaceTop7-zUdHk {
	margin-top: 42px !important;
}

.AddPopularLocationManagement-spaceTop8-E6u11 {
	margin-top: 48px !important;
}

.AddPopularLocationManagement-noMargin-v0RbN {
	margin: 0px !important;
}

.AddPopularLocationManagement-padding1-eb4LW {
	padding-bottom: 6px !important;
}

.AddPopularLocationManagement-padding2-ObJzo {
	padding-bottom: 12px !important;
}

.AddPopularLocationManagement-padding3-R_Z80 {
	padding-bottom: 18px !important;
}

.AddPopularLocationManagement-padding4-bkU8_ {
	padding-bottom: 24px !important;
}

.AddPopularLocationManagement-padding5-A3uWU {
	padding-bottom: 30px !important;
}

.AddPopularLocationManagement-padding6-Fdmhp {
	padding-bottom: 36px !important;
}

.AddPopularLocationManagement-padding7-BHYyR {
	padding-bottom: 42px !important;
}

.AddPopularLocationManagement-paddingTop1-Dz3Vg {
	padding-top: 6px !important;
}

.AddPopularLocationManagement-paddingTop2-Tlj1D {
	padding-top: 12px !important;
}

.AddPopularLocationManagement-paddingTop3-qVlfE {
	padding-top: 18px !important;
}

.AddPopularLocationManagement-paddingTop4-JyLJu {
	padding-top: 24px !important;
}

.AddPopularLocationManagement-paddingTop5-PtL0q {
	padding-top: 30px !important;
}

.AddPopularLocationManagement-paddingTop6-EkXpP {
	padding-top: 36px !important;
}

.AddPopularLocationManagement-paddingTop7-uplYG {
	padding-top: 42px !important;
}

.AddPopularLocationManagement-noPadding-VZ9hk {
	padding: 0px !important;
}

.AddPopularLocationManagement-textBold-gJrNT {
	font-weight: 500 !important;
}

.AddPopularLocationManagement-textBolder-N8xVw {
	font-weight: 700 !important;
}

.AddPopularLocationManagement-textNormal-IsSf_ {
	font-weight: normal !important;
}

.AddPopularLocationManagement-spaceBottom20-bjirn {
	margin-bottom: 20px;
}

.AddPopularLocationManagement-spaceBottom10-psnbz {
	margin-bottom: 10px;
}

.AddPopularLocationManagement-marginNone-o5NR7 {
	margin: 0;
}

.AddPopularLocationManagement-spaceBottom15-jkOWg {
	margin-bottom: 15px;
}

.AddPopularLocationManagement-marginTopNone-qzBZJ {
	margin-top: 0;
}

.AddPopularLocationManagement-spaceTop11-ICvLd {
	margin-top: 11px;
}

.AddPopularLocationManagement-spaceTop21-ZnDbA {
	margin-top: 21px;
}

.AddPopularLocationManagement-spaceTop20-R9KCN {
	margin-top: 20px;
}

.AddPopularLocationManagement-spaceTop10-WWEzx {
	margin-top: 10px;
}

/*New Design Text Colors */

.AddPopularLocationManagement-textDarkBlue-ugamm {
	color: rgb(20, 39, 94) !important;
}

.AddPopularLocationManagement-textLightBlue-hmtAW {
	color: rgb(57, 87, 106) !important;
}

.AddPopularLocationManagement-textLightSandleGreen-wSA0N {
	color: rgb(76, 86, 41) !important;
}

.AddPopularLocationManagement-textLightBrown-dvQiP {
	color: rgb(115, 79, 33) !important;
}

.AddPopularLocationManagement-textMediumMaroon-j9aV7 {
	color: rgb(87, 37, 51) !important;
}

.AddPopularLocationManagement-textBrown-ntAfC {
	color: rgb(160, 47, 24) !important;
}

.AddPopularLocationManagement-textMaroon-eSmNd {
	color: rgb(155, 49, 67) !important;
}

.AddPopularLocationManagement-textDarkBrown-PLEH8 {
	color: rgb(83, 18, 16) !important;
}

.AddPopularLocationManagement-textMediumBrown-u9nRA {
	color: rgb(142, 28, 10) !important;
}

.AddPopularLocationManagement-textSkyBlue-YPJOh {
	color: rgb(37, 117, 141) !important;
}

.AddPopularLocationManagement-textGray-oNomA {
	color: rgb(77, 65, 51) !important;
}

.AddPopularLocationManagement-btn-bJFPG,
.AddPopularLocationManagement-btn-bJFPG:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 6px 12px !important;
	width: auto;
	outline: 0 !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 4px !important;
	background: var(--background-primary) !important;
	color: var(--primary-btn-foreground) !important;
}

.AddPopularLocationManagement-btn-bJFPG:hover {
	background: var(--primary-border) !important;
	outline: 0 !important;
}

.AddPopularLocationManagement-btnPrimary-EvvaL,
.AddPopularLocationManagement-btnPrimary-EvvaL:focus {
	border-color: var(--primary-bg) !important;
	background-color: var(--primary-bg) !important;
	color: var(--primary-btn-foreground) !important;
}

.AddPopularLocationManagement-btnPrimary-EvvaL:hover {
	border-color: var(--primary-bg-hover) !important;
	background-color: var(--primary-bg-hover) !important;
	color: var(--primary-btn-foreground) !important;
}

.AddPopularLocationManagement-btnPrimaryBorder-kFwx0,
.AddPopularLocationManagement-btnPrimaryBorder-kFwx0:focus {
	border-color: var(--secondary-oscuro) !important;
	color: var(--secondary-oscuro) !important;
	background-color: var(--background-primary) !important;
}

.AddPopularLocationManagement-btnPrimaryBorder-kFwx0:hover {
	border-color: var(--primary-bg-hover) !important;
	color: var(--primary-bg-hover) !important;
	background-color: var(--background-primary) !important;
}

.AddPopularLocationManagement-btnLink-iw_Sx,
.AddPopularLocationManagement-btnLink-iw_Sx:focus,
.AddPopularLocationManagement-btnLink-iw_Sx:hover {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent !important;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: inherit;
	border: 0px !important;
}

.AddPopularLocationManagement-searchFilterPopover-cMWR3 {
	position: absolute;
	top: 51px;
	left: 0px;
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	display: inline-block;
	max-height: 65vh;
	visibility: visible;
	background: var(--background-primary);
	-webkit-box-shadow: 0px 0px 10px var(--primary-box-shadow);
	        box-shadow: 0px 0px 10px var(--primary-box-shadow);
	border-radius: 14px;
}

.AddPopularLocationManagement-searchFilterPopoverFull-l7JdZ {
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	position: fixed;
	left: 0px;
	bottom: 0px;
	width: 66%;
	height: initial;
	-webkit-box-shadow: none;
	        box-shadow: none;
	visibility: visible;
	top: 148px;
	background-color: var(--modal-bg);
	border-radius: 4px;
	border-width: initial;
	border-style: none;
	border-color: initial;
	-o-border-image: initial;
	   border-image: initial;
}

.AddPopularLocationManagement-searchFilterPopoverOverlay-qfvRF {
	position: fixed;
	height: 100vh;
	width: 100%;
	top: 64px;
	z-index: 2;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	background: rgba(255, 255, 255, 0.85);
	left: 0;
	right: 0;
	visibility: visible;
	bottom: 0;
	-webkit-overflow-scrolling: touch;
}

.AddPopularLocationManagement-dateFilterpopVerlayHeight-hWemW {
	max-height: 100%;
}

.AddPopularLocationManagement-dateFilterpopVerlayContentHeight-R2WPa {
	min-height: 100% !important;
}

.AddPopularLocationManagement-searchFilterCloseIcon-ej9Xq {
	font-size: 30px;
	color: var(--secondary-foreground);
}

.AddPopularLocationManagement-searchFilterPopoverFooter-oSxNw {
	width: 100%;
	position: relative;
	line-height: 0;
}

.AddPopularLocationManagement-displayTable-gKHI1 {
	display: table;
	width: 100%;
	vertical-align: middle;
}

.AddPopularLocationManagement-displayTableRow-ybkV6 {
	display: table-row;
	vertical-align: middle;
}

.AddPopularLocationManagement-displayTableCell-bUY7Z {
	display: table-cell;
	vertical-align: middle;
}

.AddPopularLocationManagement-displayInlineBlock-PbNvs {
	display: inline-block;
	vertical-align: top;
	white-space: normal;
}

.AddPopularLocationManagement-fullWidth-UFCwo {
	width: 100% !important;
}

.AddPopularLocationManagement-captionTitle-J900V {
	font-size: 16px;
	color: var(--primary-foreground);
}

.AddPopularLocationManagement-showTabletSection-TTkuW {
	display: none !important;
}

.AddPopularLocationManagement-blockRadioButton-oPgz3 {
	margin-top: 0;
	max-width: 320px;
	border: 1px solid var(--primary-border);
	padding: 20px;
}

.AddPopularLocationManagement-jumboSelect-OhMnc {
	height: 58px !important;
	font-size: 16px !important;
	padding: 15px 47px 20px 20px !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 4px !important;
}

.AddPopularLocationManagement-jumboSelectPadding-ePTs4 {
	padding: 15px 50px 20px 20px !important;
}

.AddPopularLocationManagement-commonBorder-T9c2M {
	border: 1px solid var(--primary-border) !important;
	color: var(--secondary-foreground) !important;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	border-radius: 3px !important;
}

.AddPopularLocationManagement-textAignRight-fT_eQ {
	text-align: right;
}

.AddPopularLocationManagement-textAlignLeft-BWBFn {
	text-align: left;
}

.AddPopularLocationManagement-textAignCenter-Co1CK {
	text-align: center;
}

.AddPopularLocationManagement-moreFilterTitle-B9XPR {
	font-size: 18px;
}

.AddPopularLocationManagement-dot-ExeJP {
	color: var(--secondary-foreground);
	font-size: 12px;
	margin-bottom: 0;
}

/*************************** Header Modal Start **********************/

.AddPopularLocationManagement-currencyAndLanguageGrid-X6Yxc {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 30px;
}

.AddPopularLocationManagement-activeItem-Dk_Bl {
	padding: 15px;
	text-align: center;
	font-size: 16px;
	border-radius: 8px;
	cursor: pointer;
	border: 1px solid var(--primary-border);
}

.AddPopularLocationManagement-activeItem-Dk_Bl:hover,
.AddPopularLocationManagement-activeItem-Dk_Bl:focus,
.AddPopularLocationManagement-activeItem-Dk_Bl:active {
	background-color: var(--common-hover-bg);
	color: var(--primary-foreground);
}

.AddPopularLocationManagement-activeSection-zXtZ6:first-child {
	background-color: var(--primary-gray-bg);
	color: var(--primary-foreground);
	border: 1px solid var(--secondary-bg);
	cursor: not-allowed;
}

.AddPopularLocationManagement-commonCloseModalBtn-krOcr {
	position: absolute;
	cursor: pointer;
}

.AddPopularLocationManagement-searchIconCommon-PwRDL {
	margin-right: 3px;
	position: relative;
	top: -1px;
}

.AddPopularLocationManagement-loginLabel-AAbJc {
	font-size: 16px;
	margin-bottom: 10px;
	font-weight: 600;
}

@media screen and (max-width: 767px) {

	.AddPopularLocationManagement-dropdownOverflow-feGoW {
		white-space: break-spaces;
		text-align: left;
	}

	.AddPopularLocationManagement-currencyAndLanguageGrid-X6Yxc {
		grid-template-columns: repeat(2, 1fr);
	}
}

@media (max-width:991px) and (min-width:768px) {
	.AddPopularLocationManagement-currencyAndLanguageGrid-X6Yxc {
		grid-template-columns: repeat(4, 1fr);
	}
}

/*************************** Header Modal End **********************/

.AddPopularLocationManagement-capitalizeText-MAi3u {
	text-transform: capitalize;
}

@media screen and (max-width: 767px) {
	.AddPopularLocationManagement-searchFilterPopoverHeader-HZoly {
		position: fixed;
		top: 0;
		z-index: 7;
		left: 0;
		right: 0;
		width: 100%;
		padding: 24px;
		border-bottom: 1px solid var(--primary-border);
		background-color: var(--modal-bg);
		border-radius: 14px 14px 0 0;
	}
}

@media screen and (max-width: 768px) {
	.AddPopularLocationManagement-searchFilterPopoverFull-l7JdZ {
		width: 100%;
		height: 100%;
		top: 0px;
		-webkit-box-shadow: none;
		        box-shadow: none;
		max-height: 100%;
		-webkit-overflow-scrolling: touch;
		border-radius: 14px;
	}

	.AddPopularLocationManagement-searchFilterPopoverContent-UkxkA {
		height: 100%;
		min-height: 100vh;
		-webkit-overflow-scrolling: touch;
	}

	.AddPopularLocationManagement-showTabletSection-TTkuW {
		display: block !important;
	}

	.AddPopularLocationManagement-hideTabletSection-sLZq3 {
		display: none !important;
	}
}

@media screen and (max-width: 767px) {
	.AddPopularLocationManagement-searchFilterPopoverFooter-oSxNw {
		position: relative !important;
	}
}

@media screen and (max-width: 350px) {
	.AddPopularLocationManagement-btnFontsize-QoePJ {
		font-size: 14px !important;
	}
}

@media (max-width: 360px) {
	.AddPopularLocationManagement-searchFilterCloseIcon-ej9Xq {
		font-size: 25px;
	}
}

@media (max-width: 993px) and (min-width: 769px) {
	.AddPopularLocationManagement-responsiveFontsize-TGbPB {
		font-size: 14px;
	}
}

/*****************Apply Button Alignment Start **********************/

.AddPopularLocationManagement-applyBtnDesktop-QDkTd {
	text-align: right;
}

@media screen and (max-width: 991px) {
	.AddPopularLocationManagement-applyBtnDesktop-QDkTd {
		text-align: center;
	}

	.AddPopularLocationManagement-applyBtnDesktopRight-xpD14 {
		text-align: right !important;
	}

	.AddPopularLocationManagement-applyBtnDesktopNoPaddingRight-XFw05 {
		padding-right: 0px !important;
	}

}

/*****************Apply Button Alignment Start **********************/

.AddPopularLocationManagement-popularLocationGeoSuggestion-bm9RW{
    width: 100%;
    background-color: transparent !important;
}

.AddPopularLocationManagement-mobilePadding-CZKkc{
    padding: 24px 12px;
}

.AddPopularLocationManagement-blockCenter-rEtw4{
    margin-bottom: 100px;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css","webpack://./src/components/common.css","webpack://./src/components/siteadmin/AddPopularLocation/AddPopularLocationManagement.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACzNA;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,4BAA4B;CAC5B,WAAW;CACX,qBAAqB;CACrB,kDAAkD;CAClD,6BAA6B;CAC7B,gDAAgD;CAChD,+CAA+C;AAChD;;AAEA;CACC,4CAA4C;CAC5C,qBAAqB;AACtB;;AAEA;;CAEC,0CAA0C;CAC1C,8CAA8C;CAC9C,+CAA+C;AAChD;;AAEA;CACC,gDAAgD;CAChD,oDAAoD;CACpD,+CAA+C;AAChD;;AAEA;;CAEC,gDAAgD;CAChD,yCAAyC;CACzC,sDAAsD;AACvD;;AAEA;CACC,gDAAgD;CAChD,yCAAyC;CACzC,sDAAsD;AACvD;;AAEA;;;CAGC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kCAAkC;CAClC,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;CACnB,qCAAqC;CACrC,0DAAkD;SAAlD,kDAAkD;CAClD,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,SAAS;CACT,WAAW;CACX,UAAU;CACV,eAAe;CACf,wBAAgB;SAAhB,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;CACV,iCAAiC;CACjC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,qBAAqB;CACrB,wBAAqB;IAArB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,aAAa;CACb,WAAW;CACX,SAAS;CACT,UAAU;CACV,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qCAAqC;CACrC,OAAO;CACP,QAAQ;CACR,mBAAmB;CACnB,SAAS;CACT,iCAAiC;AAClC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,uCAAuC;CACvC,aAAa;AACd;;AAEA;CACC,uBAAuB;CACvB,0BAA0B;CAC1B,uCAAuC;CACvC,kDAAkD;CAClD,6BAA6B;AAC9B;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,kDAAkD;CAClD,6CAA6C;CAC7C,mCAA2B;SAA3B,2BAA2B;CAC3B,6BAA6B;AAC9B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,gBAAgB;AACjB;;AAEA,sEAAsE;;AACtE;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,uCAAuC;AACxC;;AAGA;;;CAGC,wCAAwC;CACxC,gCAAgC;AACjC;;AAEA;CACC,wCAAwC;CACxC,gCAAgC;CAChC,qCAAqC;CACrC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,gBAAgB;AACjB;;AAGA;;CAEC;EACC,yBAAyB;EACzB,gBAAgB;CACjB;;CAEA;EACC,qCAAqC;CACtC;AACD;;AAEA;CACC;EACC,qCAAqC;CACtC;AACD;;AAEA,oEAAoE;;AAEpE;CACC,0BAA0B;AAC3B;;AAEA;CACC;EACC,eAAe;EACf,MAAM;EACN,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,8CAA8C;EAC9C,iCAAiC;EACjC,4BAA4B;CAC7B;AACD;;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,wBAAgB;UAAhB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;CACpB;;CAEA;EACC,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;CAClC;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC;EACC,6BAA6B;CAC9B;AACD;;AAEA;CACC;EACC,0BAA0B;CAC3B;AACD;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA,qEAAqE;;AAErE;CACC,iBAAiB;AAClB;;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,6BAA6B;CAC9B;;AAED;;AAEA,qEAAqE;;ACvXrE;IACI,WAAW;IACX,wCAAwC;AAC5C;;AACA;IACI,kBAAkB;AACtB;;AACA;IACI,oBAAoB;AACxB","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import 'utils.css';\n@import 'helpers.css';\n\n.btn,\n.btn:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 6px 12px !important;\n\twidth: auto;\n\toutline: 0 !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 4px !important;\n\tbackground: var(--background-primary) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btn:hover {\n\tbackground: var(--primary-border) !important;\n\toutline: 0 !important;\n}\n\n.btnPrimary,\n.btnPrimary:focus {\n\tborder-color: var(--primary-bg) !important;\n\tbackground-color: var(--primary-bg) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btnPrimary:hover {\n\tborder-color: var(--primary-bg-hover) !important;\n\tbackground-color: var(--primary-bg-hover) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btnPrimaryBorder,\n.btnPrimaryBorder:focus {\n\tborder-color: var(--secondary-oscuro) !important;\n\tcolor: var(--secondary-oscuro) !important;\n\tbackground-color: var(--background-primary) !important;\n}\n\n.btnPrimaryBorder:hover {\n\tborder-color: var(--primary-bg-hover) !important;\n\tcolor: var(--primary-bg-hover) !important;\n\tbackground-color: var(--background-primary) !important;\n}\n\n.btnLink,\n.btnLink:focus,\n.btnLink:hover {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent !important;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: inherit;\n\tborder: 0px !important;\n}\n\n.searchFilterPopover {\n\tposition: absolute;\n\ttop: 51px;\n\tleft: 0px;\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tdisplay: inline-block;\n\tmax-height: 65vh;\n\tvisibility: visible;\n\tbackground: var(--background-primary);\n\tbox-shadow: 0px 0px 10px var(--primary-box-shadow);\n\tborder-radius: 14px;\n}\n\n.searchFilterPopoverFull {\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: 0px;\n\twidth: 66%;\n\theight: initial;\n\tbox-shadow: none;\n\tvisibility: visible;\n\ttop: 148px;\n\tbackground-color: var(--modal-bg);\n\tborder-radius: 4px;\n\tborder-width: initial;\n\tborder-style: none;\n\tborder-color: initial;\n\tborder-image: initial;\n}\n\n.searchFilterPopoverOverlay {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100%;\n\ttop: 64px;\n\tz-index: 2;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tbackground: rgba(255, 255, 255, 0.85);\n\tleft: 0;\n\tright: 0;\n\tvisibility: visible;\n\tbottom: 0;\n\t-webkit-overflow-scrolling: touch;\n}\n\n.dateFilterpopVerlayHeight {\n\tmax-height: 100%;\n}\n\n.dateFilterpopVerlayContentHeight {\n\tmin-height: 100% !important;\n}\n\n.searchFilterCloseIcon {\n\tfont-size: 30px;\n\tcolor: var(--secondary-foreground);\n}\n\n.searchFilterPopoverFooter {\n\twidth: 100%;\n\tposition: relative;\n\tline-height: 0;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n\tvertical-align: middle;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\tvertical-align: middle;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.displayInlineBlock {\n\tdisplay: inline-block;\n\tvertical-align: top;\n\twhite-space: normal;\n}\n\n.fullWidth {\n\twidth: 100% !important;\n}\n\n.captionTitle {\n\tfont-size: 16px;\n\tcolor: var(--primary-foreground);\n}\n\n.showTabletSection {\n\tdisplay: none !important;\n}\n\n.blockRadioButton {\n\tmargin-top: 0;\n\tmax-width: 320px;\n\tborder: 1px solid var(--primary-border);\n\tpadding: 20px;\n}\n\n.jumboSelect {\n\theight: 58px !important;\n\tfont-size: 16px !important;\n\tpadding: 15px 47px 20px 20px !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 4px !important;\n}\n\n.jumboSelectPadding {\n\tpadding: 15px 50px 20px 20px !important;\n}\n\n.commonBorder {\n\tborder: 1px solid var(--primary-border) !important;\n\tcolor: var(--secondary-foreground) !important;\n\tbox-shadow: none !important;\n\tborder-radius: 3px !important;\n}\n\n.textAignRight {\n\ttext-align: right;\n}\n\n.textAlignLeft {\n\ttext-align: left;\n}\n\n.textAignCenter {\n\ttext-align: center;\n}\n\n.moreFilterTitle {\n\tfont-size: 18px;\n}\n\n.dot {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 12px;\n\tmargin-bottom: 0;\n}\n\n/*************************** Header Modal Start **********************/\n.currencyAndLanguageGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(5, 1fr);\n\tgap: 30px;\n}\n\n.activeItem {\n\tpadding: 15px;\n\ttext-align: center;\n\tfont-size: 16px;\n\tborder-radius: 8px;\n\tcursor: pointer;\n\tborder: 1px solid var(--primary-border);\n}\n\n\n.activeItem:hover,\n.activeItem:focus,\n.activeItem:active {\n\tbackground-color: var(--common-hover-bg);\n\tcolor: var(--primary-foreground);\n}\n\n.activeSection:first-child {\n\tbackground-color: var(--primary-gray-bg);\n\tcolor: var(--primary-foreground);\n\tborder: 1px solid var(--secondary-bg);\n\tcursor: not-allowed;\n}\n\n.commonCloseModalBtn {\n\tposition: absolute;\n\tcursor: pointer;\n}\n\n.searchIconCommon {\n\tmargin-right: 3px;\n\tposition: relative;\n\ttop: -1px;\n}\n\n.loginLabel {\n\tfont-size: 16px;\n\tmargin-bottom: 10px;\n\tfont-weight: 600;\n}\n\n\n@media screen and (max-width: 767px) {\n\n\t.dropdownOverflow {\n\t\twhite-space: break-spaces;\n\t\ttext-align: left;\n\t}\n\n\t.currencyAndLanguageGrid {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n\n@media (max-width:991px) and (min-width:768px) {\n\t.currencyAndLanguageGrid {\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t}\n}\n\n/*************************** Header Modal End **********************/\n\n.capitalizeText {\n\ttext-transform: capitalize;\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverHeader {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tz-index: 7;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: 100%;\n\t\tpadding: 24px;\n\t\tborder-bottom: 1px solid var(--primary-border);\n\t\tbackground-color: var(--modal-bg);\n\t\tborder-radius: 14px 14px 0 0;\n\t}\n}\n\n@media screen and (max-width: 768px) {\n\t.searchFilterPopoverFull {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0px;\n\t\tbox-shadow: none;\n\t\tmax-height: 100%;\n\t\t-webkit-overflow-scrolling: touch;\n\t\tborder-radius: 14px;\n\t}\n\n\t.searchFilterPopoverContent {\n\t\theight: 100%;\n\t\tmin-height: 100vh;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.showTabletSection {\n\t\tdisplay: block !important;\n\t}\n\n\t.hideTabletSection {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverFooter {\n\t\tposition: relative !important;\n\t}\n}\n\n@media screen and (max-width: 350px) {\n\t.btnFontsize {\n\t\tfont-size: 14px !important;\n\t}\n}\n\n@media (max-width: 360px) {\n\t.searchFilterCloseIcon {\n\t\tfont-size: 25px;\n\t}\n}\n\n@media (max-width: 993px) and (min-width: 769px) {\n\t.responsiveFontsize {\n\t\tfont-size: 14px;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n\n.applyBtnDesktop {\n\ttext-align: right;\n}\n\n@media screen and (max-width: 991px) {\n\t.applyBtnDesktop {\n\t\ttext-align: center;\n\t}\n\n\t.applyBtnDesktopRight {\n\t\ttext-align: right !important;\n\t}\n\n\t.applyBtnDesktopNoPaddingRight {\n\t\tpadding-right: 0px !important;\n\t}\n\n}\n\n/*****************Apply Button Alignment Start **********************/","@import '../admin-common.css';\n@import '../admin-form.css';\n@import '../../common.css';\n@import '../../helpers.css';\n\n.popularLocationGeoSuggestion{\n    width: 100%;\n    background-color: transparent !important;\n}\n.mobilePadding{\n    padding: 24px 12px;\n}\n.blockCenter{\n    margin-bottom: 100px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `AddPopularLocationManagement-commonHeaderAdmin-f8KVM`,
	"adminLayout": `AddPopularLocationManagement-adminLayout-cG5WM`,
	"box": `AddPopularLocationManagement-box-hFql1`,
	"exportLink": `AddPopularLocationManagement-exportLink-t7iv6`,
	"blockCenter": `AddPopularLocationManagement-blockCenter-rEtw4`,
	"panelHeader": `AddPopularLocationManagement-panelHeader-qiRIs`,
	"currencyselect": `AddPopularLocationManagement-currencyselect-rsOD3`,
	"mar0": `AddPopularLocationManagement-mar0-yX7IM`,
	"sideAdminPageWrapper": `AddPopularLocationManagement-sideAdminPageWrapper-cmt0e`,
	"table": `AddPopularLocationManagement-table-y0oX7`,
	"tableRow": `AddPopularLocationManagement-tableRow-vRSqv`,
	"tableCell": `AddPopularLocationManagement-tableCell-zqdOA`,
	"formGroup": `AddPopularLocationManagement-formGroup-uucAE`,
	"select": `AddPopularLocationManagement-select-ZBWfP`,
	"noMargin": `AddPopularLocationManagement-noMargin-v0RbN`,
	"labelTextNew": `AddPopularLocationManagement-labelTextNew-tbQYD`,
	"displayInline": `AddPopularLocationManagement-displayInline-raarw`,
	"btnUPdate": `AddPopularLocationManagement-btnUPdate-P3moK`,
	"btnModalDelete": `AddPopularLocationManagement-btnModalDelete-zuWfs`,
	"radioBtn": `AddPopularLocationManagement-radioBtn-qDjI6`,
	"backgroundImg": `AddPopularLocationManagement-backgroundImg-ZS3Qv`,
	"btnWidth": `AddPopularLocationManagement-btnWidth-VR0Wu`,
	"bannerImageBg": `AddPopularLocationManagement-bannerImageBg-mft_Z`,
	"bannerDelete": `AddPopularLocationManagement-bannerDelete-sirYu`,
	"modalRoot": `AddPopularLocationManagement-modalRoot-siG8d`,
	"modalBorderBottom": `AddPopularLocationManagement-modalBorderBottom-yHR9F`,
	"logInModalBody": `AddPopularLocationManagement-logInModalBody-yVmG6`,
	"exportSection": `AddPopularLocationManagement-exportSection-XHdLK`,
	"exportSectionGridSub": `AddPopularLocationManagement-exportSectionGridSub-Ertvh`,
	"exportText": `AddPopularLocationManagement-exportText-_jOMc`,
	"exportLinkImg": `AddPopularLocationManagement-exportLinkImg-raqYg`,
	"vtrMiddle": `AddPopularLocationManagement-vtrMiddle-TdHey`,
	"exportImg": `AddPopularLocationManagement-exportImg-jK_VZ`,
	"profileViewlabel": `AddPopularLocationManagement-profileViewlabel-kQ1Iy`,
	"profileViewMainContent": `AddPopularLocationManagement-profileViewMainContent-ZQr6M`,
	"profileViewMain": `AddPopularLocationManagement-profileViewMain-gNLxd`,
	"profileViewInner": `AddPopularLocationManagement-profileViewInner-V_61m`,
	"profileImageSection": `AddPopularLocationManagement-profileImageSection-bOZNm`,
	"lastviewInner": `AddPopularLocationManagement-lastviewInner-_8Kfq`,
	"whyHostHoriLine": `AddPopularLocationManagement-whyHostHoriLine-fs3BY`,
	"tableGrid": `AddPopularLocationManagement-tableGrid-OWA5j`,
	"headingContent": `AddPopularLocationManagement-headingContent-htVCF`,
	"refundTextColor": `AddPopularLocationManagement-refundTextColor-rfQP4`,
	"dividerLine": `AddPopularLocationManagement-dividerLine-AYbCr`,
	"smallContent": `AddPopularLocationManagement-smallContent-WC074`,
	"ChangeToUpperCase": `AddPopularLocationManagement-ChangeToUpperCase-C4jrV`,
	"noBorder": `AddPopularLocationManagement-noBorder-guXlO`,
	"siteAdminHeading": `AddPopularLocationManagement-siteAdminHeading-OCy7T`,
	"siteAdminSubHeading": `AddPopularLocationManagement-siteAdminSubHeading-Pp2lE`,
	"adminFormDivider": `AddPopularLocationManagement-adminFormDivider-XysWv`,
	"errorMessage": `AddPopularLocationManagement-errorMessage-BSI9U`,
	"labelText": `AddPopularLocationManagement-labelText-QqS6d`,
	"space1": `AddPopularLocationManagement-space1-fiNX0`,
	"space2": `AddPopularLocationManagement-space2-frGP3`,
	"space3": `AddPopularLocationManagement-space3-VC3A0`,
	"space4": `AddPopularLocationManagement-space4-ee3Wf`,
	"space5": `AddPopularLocationManagement-space5-OhLzk`,
	"space6": `AddPopularLocationManagement-space6-EO7L3`,
	"space7": `AddPopularLocationManagement-space7-V83PY`,
	"spaceTop8": `AddPopularLocationManagement-spaceTop8-E6u11`,
	"spaceTop1": `AddPopularLocationManagement-spaceTop1-mTAeK`,
	"spaceTop2": `AddPopularLocationManagement-spaceTop2-DLaFe`,
	"spaceTop3": `AddPopularLocationManagement-spaceTop3-tNG5Z`,
	"spaceTop4": `AddPopularLocationManagement-spaceTop4-sDLZB`,
	"spaceTop5": `AddPopularLocationManagement-spaceTop5-LWwup`,
	"spaceTop6": `AddPopularLocationManagement-spaceTop6-DaH0O`,
	"spaceTop7": `AddPopularLocationManagement-spaceTop7-zUdHk`,
	"padding1": `AddPopularLocationManagement-padding1-eb4LW`,
	"padding2": `AddPopularLocationManagement-padding2-ObJzo`,
	"padding3": `AddPopularLocationManagement-padding3-R_Z80`,
	"padding4": `AddPopularLocationManagement-padding4-bkU8_`,
	"padding5": `AddPopularLocationManagement-padding5-A3uWU`,
	"padding6": `AddPopularLocationManagement-padding6-Fdmhp`,
	"padding7": `AddPopularLocationManagement-padding7-BHYyR`,
	"paddingTop1": `AddPopularLocationManagement-paddingTop1-Dz3Vg`,
	"paddingTop2": `AddPopularLocationManagement-paddingTop2-Tlj1D`,
	"paddingTop3": `AddPopularLocationManagement-paddingTop3-qVlfE`,
	"paddingTop4": `AddPopularLocationManagement-paddingTop4-JyLJu`,
	"paddingTop5": `AddPopularLocationManagement-paddingTop5-PtL0q`,
	"paddingTop6": `AddPopularLocationManagement-paddingTop6-EkXpP`,
	"paddingTop7": `AddPopularLocationManagement-paddingTop7-uplYG`,
	"noPadding": `AddPopularLocationManagement-noPadding-VZ9hk`,
	"textBold": `AddPopularLocationManagement-textBold-gJrNT`,
	"textBolder": `AddPopularLocationManagement-textBolder-N8xVw`,
	"textNormal": `AddPopularLocationManagement-textNormal-IsSf_`,
	"spaceBottom20": `AddPopularLocationManagement-spaceBottom20-bjirn`,
	"spaceBottom10": `AddPopularLocationManagement-spaceBottom10-psnbz`,
	"marginNone": `AddPopularLocationManagement-marginNone-o5NR7`,
	"spaceBottom15": `AddPopularLocationManagement-spaceBottom15-jkOWg`,
	"marginTopNone": `AddPopularLocationManagement-marginTopNone-qzBZJ`,
	"spaceTop11": `AddPopularLocationManagement-spaceTop11-ICvLd`,
	"spaceTop21": `AddPopularLocationManagement-spaceTop21-ZnDbA`,
	"spaceTop20": `AddPopularLocationManagement-spaceTop20-R9KCN`,
	"spaceTop10": `AddPopularLocationManagement-spaceTop10-WWEzx`,
	"textDarkBlue": `AddPopularLocationManagement-textDarkBlue-ugamm`,
	"textLightBlue": `AddPopularLocationManagement-textLightBlue-hmtAW`,
	"textLightSandleGreen": `AddPopularLocationManagement-textLightSandleGreen-wSA0N`,
	"textLightBrown": `AddPopularLocationManagement-textLightBrown-dvQiP`,
	"textMediumMaroon": `AddPopularLocationManagement-textMediumMaroon-j9aV7`,
	"textBrown": `AddPopularLocationManagement-textBrown-ntAfC`,
	"textMaroon": `AddPopularLocationManagement-textMaroon-eSmNd`,
	"textDarkBrown": `AddPopularLocationManagement-textDarkBrown-PLEH8`,
	"textMediumBrown": `AddPopularLocationManagement-textMediumBrown-u9nRA`,
	"textSkyBlue": `AddPopularLocationManagement-textSkyBlue-YPJOh`,
	"textGray": `AddPopularLocationManagement-textGray-oNomA`,
	"btn": `AddPopularLocationManagement-btn-bJFPG`,
	"btnPrimary": `AddPopularLocationManagement-btnPrimary-EvvaL`,
	"btnPrimaryBorder": `AddPopularLocationManagement-btnPrimaryBorder-kFwx0`,
	"btnLink": `AddPopularLocationManagement-btnLink-iw_Sx`,
	"searchFilterPopover": `AddPopularLocationManagement-searchFilterPopover-cMWR3`,
	"searchFilterPopoverFull": `AddPopularLocationManagement-searchFilterPopoverFull-l7JdZ`,
	"searchFilterPopoverOverlay": `AddPopularLocationManagement-searchFilterPopoverOverlay-qfvRF`,
	"dateFilterpopVerlayHeight": `AddPopularLocationManagement-dateFilterpopVerlayHeight-hWemW`,
	"dateFilterpopVerlayContentHeight": `AddPopularLocationManagement-dateFilterpopVerlayContentHeight-R2WPa`,
	"searchFilterCloseIcon": `AddPopularLocationManagement-searchFilterCloseIcon-ej9Xq`,
	"searchFilterPopoverFooter": `AddPopularLocationManagement-searchFilterPopoverFooter-oSxNw`,
	"displayTable": `AddPopularLocationManagement-displayTable-gKHI1`,
	"displayTableRow": `AddPopularLocationManagement-displayTableRow-ybkV6`,
	"displayTableCell": `AddPopularLocationManagement-displayTableCell-bUY7Z`,
	"displayInlineBlock": `AddPopularLocationManagement-displayInlineBlock-PbNvs`,
	"fullWidth": `AddPopularLocationManagement-fullWidth-UFCwo`,
	"captionTitle": `AddPopularLocationManagement-captionTitle-J900V`,
	"showTabletSection": `AddPopularLocationManagement-showTabletSection-TTkuW`,
	"blockRadioButton": `AddPopularLocationManagement-blockRadioButton-oPgz3`,
	"jumboSelect": `AddPopularLocationManagement-jumboSelect-OhMnc`,
	"jumboSelectPadding": `AddPopularLocationManagement-jumboSelectPadding-ePTs4`,
	"commonBorder": `AddPopularLocationManagement-commonBorder-T9c2M`,
	"textAignRight": `AddPopularLocationManagement-textAignRight-fT_eQ`,
	"textAlignLeft": `AddPopularLocationManagement-textAlignLeft-BWBFn`,
	"textAignCenter": `AddPopularLocationManagement-textAignCenter-Co1CK`,
	"moreFilterTitle": `AddPopularLocationManagement-moreFilterTitle-B9XPR`,
	"dot": `AddPopularLocationManagement-dot-ExeJP`,
	"currencyAndLanguageGrid": `AddPopularLocationManagement-currencyAndLanguageGrid-X6Yxc`,
	"activeItem": `AddPopularLocationManagement-activeItem-Dk_Bl`,
	"activeSection": `AddPopularLocationManagement-activeSection-zXtZ6`,
	"commonCloseModalBtn": `AddPopularLocationManagement-commonCloseModalBtn-krOcr`,
	"searchIconCommon": `AddPopularLocationManagement-searchIconCommon-PwRDL`,
	"loginLabel": `AddPopularLocationManagement-loginLabel-AAbJc`,
	"dropdownOverflow": `AddPopularLocationManagement-dropdownOverflow-feGoW`,
	"capitalizeText": `AddPopularLocationManagement-capitalizeText-MAi3u`,
	"searchFilterPopoverHeader": `AddPopularLocationManagement-searchFilterPopoverHeader-HZoly`,
	"searchFilterPopoverContent": `AddPopularLocationManagement-searchFilterPopoverContent-UkxkA`,
	"hideTabletSection": `AddPopularLocationManagement-hideTabletSection-sLZq3`,
	"btnFontsize": `AddPopularLocationManagement-btnFontsize-QoePJ`,
	"responsiveFontsize": `AddPopularLocationManagement-responsiveFontsize-TGbPB`,
	"applyBtnDesktop": `AddPopularLocationManagement-applyBtnDesktop-QDkTd`,
	"applyBtnDesktopRight": `AddPopularLocationManagement-applyBtnDesktopRight-xpD14`,
	"applyBtnDesktopNoPaddingRight": `AddPopularLocationManagement-applyBtnDesktopNoPaddingRight-XFw05`,
	"popularLocationGeoSuggestion": `AddPopularLocationManagement-popularLocationGeoSuggestion-bm9RW`,
	"mobilePadding": `AddPopularLocationManagement-mobilePadding-CZKkc`
};
module.exports = ___CSS_LOADER_EXPORT___;
